import { useEffect, useState } from "react";
import { api } from "../api";
import { getStepLabel } from "../utils/follow-up-steps";

export default function HistoryModal({ followUpId, onClose }) {

  const [history, setHistory] = useState([]);

  useEffect(() => {
    let isMounted = true;

    async function loadHistory() {
      const response = await api.get(`/followups/${followUpId}/history`);
      if (isMounted) {
        setHistory(response.data);
      }
    }

    loadHistory();

    return () => {
      isMounted = false;
    };
  }, [followUpId]);

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal">

        <h5>Histórico de Tentativas</h5>

        {history.length === 0 ? (
          <p>Nenhuma tentativa registrada.</p>
        ) : (
          history.map((item) => (
            <div key={item.id} className="border p-2 mb-2 rounded">

              <strong>{getStepLabel(item.step)}</strong>

              <div>
                {new Date(item.createdAt).toLocaleDateString()}
              </div>

              <div>
                {item.notes || "Sem observação"}
              </div>

              <div>
                Status: {item.success ? "Sucesso" : "Sem retorno"}
              </div>

            </div>
          ))
        )}

        <div className="text-end mt-3">
          <button className="btn btn-secondary" onClick={onClose}>
            Fechar
          </button>
        </div>

      </div>
    </div>
  );
}
